import { SaveableSettingsProvider } from "./saveable-settings-provider";

export class ViewSaveableSettingsProvider extends SaveableSettingsProvider {
  constructor(canvasSettingsProvider) {
    super();
    this.canvasSettingsProvider = canvasSettingsProvider;
  }

  createSaveableSettings(settings) {
    const saveableSettings = {
      configVersion: settings.configVersion,
      view: {}
    };
    if (settings.view?.canvas !== undefined && this.canvasSettingsProvider !== undefined) {
      saveableSettings.view.canvas = this.canvasSettingsProvider.createSaveableSettings(settings.view.canvas);
    }
    return saveableSettings;
  }

  applySaveableSettings(settings, saveableSettings) {
    if (
      saveableSettings === undefined ||
      settings.configVersion != saveableSettings.configVersion ||
      settings.view?.canvas === undefined ||
      saveableSettings.view?.canvas === undefined ||
      this.canvasSettingsProvider === undefined
    ) {
      return;
    }
    this.canvasSettingsProvider.applySaveableSettings(settings.view.canvas, saveableSettings.view.canvas);
  }
}
